import ROUTE from "@app/navigationApp/routes";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import { CaretRight } from '@sharedComponents/Icons/Icons';
import { Image, ScrollView } from "react-native";
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';

const CarouselCards = ({ pendingRequestDetails,pendingAccountRequest, navigation }) => {
    const { renewalRequestDetailsList, disbursalDetailsList,collectionDetailsList,enhanceLimitRequestDetailsList,revocationRequestDetailsList } = pendingRequestDetails || {};
    const cardList = [];
    const transactionStatusList = [];
    disbursalDetailsList?.forEach((disbursalDetail, index) => {
        transactionStatusList.push({
            title: `₹${formatIndianCurrency(disbursalDetail?.amount)} processing for withdrawal`,
            date:disbursalDetail?.createdOn
        });
    })
    collectionDetailsList?.forEach((collectionDetail, index) => {
        transactionStatusList.push({
            title: `₹${formatIndianCurrency(collectionDetail?.actualAmountCollected)} processing for repayment`,
            date:collectionDetail?.paymentDate
        });
    });
    const sortedDetailsList = transactionStatusList?.sort((a, b) => b.date - a.date);
    if(transactionStatusList.length>0){
        const subTitle = sortedDetailsList?.length > 1 ? `+${sortedDetailsList?.length - 1} more transactions.` : '';
        cardList.push({...sortedDetailsList[0],type: ROUTE.TRANSACTION_SCREEN, subTitle: subTitle+' View details'});
    }
    // if (enhanceLimitRequestDetailsList?.length > 0) {
    //     cardList.push({
    //         title: "Request for additional credit limit",
    //         subTitle: "We're processing your request. Track status",
    //         type: "ENHANCE"
    //     })
    // }
    // if (revocationRequestDetailsList?.length > 0) {
    //     cardList.push({
    //         title: "Unpledge request in progress",
    //         subTitle: "This may take up to 3-4 business days",
    //         type: ROUTE.PLEDGE_HISTORY
    //     })
    // }
    if(pendingAccountRequest?.length>0){
        const rejections = ["FAILURE","REJECTED"]
        const isrequestRejected = rejections.includes(pendingAccountRequest[0]?.status)
        const requestType = pendingAccountRequest[0]?.requestType
        const obj = {
            PHONE_NUMBER :'Mobile number ',
            EMAIL : 'Email ID '
        }
        cardList.push({
            title: `${obj[requestType]}update ${isrequestRejected ? 'request failed':'in progress'}`,
            subTitle: isrequestRejected ? "":"Expected completion in 1-3 business days",
            type: ROUTE.ACCOUNT_DETAILS
        }) 

    }
    if(renewalRequestDetailsList?.length>0){
        cardList.push({
            title: 'Loan renewal in progress',
            subTitle: "We’re processing your request. Track status",
            type: ROUTE.RENEWAL_STATUS
        }) 
    }

    const renderDisbursalCard = (data, index) => (
        <ThemedPressable
            key={index}
            onPress={() => navigation.navigate(data.type)}
            backgroundColor="bg-surface-primary"
            borderRadius="sm"
            p="sm"
            borderWidth={1}
            borderColor="border-primary"
            mr="sm"
            {...(cardList.length === 1 &&{ flex: 1 } )}
        >
                <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                    <ThemedView flexDirection="row" alignItems="center" mr="lg">
                        {data?.title.includes('failed') ? 
                        <WarningCircle size={32} weight="fill" color={themeColorSet["icon-error"]} />
                        :
                        <Image source={{ uri: `https://volt-images-alpha.s3.ap-south-1.amazonaws.com/${data?.type===ROUTE.ACCOUNT_DETAILS?'Inprogress_icon':'rupee_aura'}.png` }} style={{ width: 32, height: 32 }} />
                        }
                        <ThemedView ml="sm">
                            <ThemedText variant="b4s" color="text-primary">{data?.title}</ThemedText>
                            <ThemedText variant="b5s" color="text-secondary">{data?.subTitle}</ThemedText>
                        </ThemedView>
                    </ThemedView>
                    <CaretRight />
                </ThemedView>
        </ThemedPressable>
    );
    if(cardList.length===0) return null;
    return (
        <>
            <ThemedView mt="lg" ml="lg" mr="sm" flex={1}>
                {cardList.length > 1 ? (
                    <ScrollView contentContainerStyle={{ flex: 1 }} horizontal showsHorizontalScrollIndicator={false}>
                        {cardList?.length > 0 && cardList.map(renderDisbursalCard)}
                    </ScrollView>
                ) : (
                    <ThemedView flexDirection="row" flex={1}>
                        {cardList?.length > 0 && cardList.map(renderDisbursalCard)}
                    </ThemedView>
                )}
            </ThemedView>
        </>
    );
};

export default CarouselCards;